import { init } from './init'
import { sanitizeData, sanitizeExpire } from './Sanitize'

const actionTypes = {
  FETCH_CMS_JWT: 'FETCH_CMS_JWT',
  RESET: 'RESET',
}

const fetchReset = async state => {
  state = {
    ...state,
    isLoading: false,
    isStatus: true,
    expireToken: false,
    data: false,
  }
  return state
}

const fetchCmsJwt = async (state, cmsjwt) => {
  state = {
    ...state,
    isStatus: cmsjwt.status,
    expireToken: sanitizeExpire({
      status: cmsjwt.status,
      data: cmsjwt.data,
      name: 'cmsjwtobj',
    }),
    data: sanitizeData({
      status: cmsjwt.status,
      data: cmsjwt.data,
      name: 'cmsjwtobj',
    }),
  }
  return state
}

const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.FETCH_CMS_JWT:
      return fetchCmsJwt(state, action.cmsjwt)
    case actionTypes.RESET:
      return fetchReset(state)
    default:
      return state
  }
}

const cmsjwt = {
  init,
  actionTypes,
  reducer,
}

export default cmsjwt
